import { MyAccountTheme, MaSessionErrorModalClasses } from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const sessionErrorModalStyles = makeStyles<
  MyAccountTheme,
  object,
  MaSessionErrorModalClasses
>(
  ({ palette }) => ({
    title: {
      color: palette.primary.main,
      textAlign: 'center',
      fontWeight: 600,
    },
    actionsRoot: {
      justifyContent: 'center',
      paddingBottom: 20,
    },
    content: {
      textAlign: 'center',
    },
    close: {
      margin: '8px 8px 8px 0',
      alignSelf: 'flex-end',
      cursor: 'pointer',
      color: palette.primary.main,
    },
    button: {},
    container: {},
    closeContainer: {
      padding: 0,
    },
  }),
  { name: 'MyAccount_SessionErrorModal' }
)

export default sessionErrorModalStyles
